import { render } from "./stackedChart.vue?vue&type=template&id=58ae954d&scoped=true&ts=true"
import script from "./stackedChart.vue?vue&type=script&lang=ts"
export * from "./stackedChart.vue?vue&type=script&lang=ts"

import "./stackedChart.vue?vue&type=style&index=0&id=58ae954d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ae954d"]])

export default __exports__